import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { attachLinkQueryParam } from './helpers';
import { DEFAULT_PARAM_NAME, DEFAULT_SELECTOR } from './constants';

// Adds a query parameter, e.g. ?offer=XMAS26, to the links inside a section of the page, so
// visitors reach product pages with the offer (KEL-479). The value comes from the page url
// when it has one and from the editor's default otherwise. Renders nothing: all the work is
// done after mount, so the server html carries no value and stays cacheable.
const LinkQueryParam = ({ paramName, defaultValue, selector }) => {
  const { asPath } = useRouter() || {};

  useEffect(() => {
    let cleanup = null;
    try {
      cleanup = attachLinkQueryParam({ paramName, defaultValue, selector });
    } catch (error) {
      // Links keep their original urls and navigate as normal
    }
    return () => {
      if (cleanup) cleanup();
    };
    // asPath re-runs it when the visitor moves to a url with a different query string
  }, [asPath, paramName, defaultValue, selector]);

  return null;
};

LinkQueryParam.propTypes = {
  paramName: PropTypes.string,
  defaultValue: PropTypes.string,
  selector: PropTypes.string
};

LinkQueryParam.defaultProps = {
  paramName: DEFAULT_PARAM_NAME,
  defaultValue: '',
  selector: DEFAULT_SELECTOR
};

export default LinkQueryParam;
